import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import getIconComponent from "./iconMapper";
import LandingCardComponent from "../../common/components/LandingCardComponent.jsx";

const parentId = 4; // "Agent"

const IconMapper = ({ iconName }) => {
  const Icon = getIconComponent(iconName);
  return <Icon style={{ fontSize: 36, color: "#1976d2" }} />;
};

const AgentLandingPage = () => {
  const navigate = useNavigate();

  // Retrieve and parse the usermenu from localStorage
  const usermenu = useMemo(() => {
    try {
      const stored = localStorage.getItem("usermenu");
      const parsed = stored ? JSON.parse(stored) : null;

      console.log("👀 Parsed usermenu from localStorage:", parsed);

      return Array.isArray(parsed?.usermenu) ? parsed.usermenu : [];
    } catch (error) {
      console.error("❌ Failed to parse usermenu from localStorage:", error);
      return [];
    }
  }, []);

  // Filter child menus for Agent section
  const childMenus = useMemo(() => {
    return usermenu
      ?.filter(item => item.parentid === parentId)
      .sort((a, b) => a.menuorderid - b.menuorderid);
  }, [usermenu]);

  function chunkArray(arr, size) {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  }

  return (
    <div className="p-6">

          {childMenus?.length > 0 ? (
            <table className="w-full border-collapse">
              <tbody>
                {chunkArray(childMenus, 3).map((menuRow, rowIndex) => (
                  <tr key={rowIndex}>
                    {menuRow.map((menu) => (
                      <td
                        key={menu.menuorderid}
                        onClick={() => navigate(menu.menupath)}
                        className="cursor-pointer border border-gray-300 p-6 text-center align-middle hover:bg-gray-50"
                        style={{ verticalAlign: 'middle', width: '33.33%' }}
                      >
                        <LandingCardComponent
                          title={menu.menuname}
                          icon={<IconMapper iconName={menu.menuicon} />}
                        />
                      </td>
                    ))}
                    {/* If last row has less than 3 items, fill empty cells */}
                    {menuRow.length < 3 &&
                      Array.from({ length: 3 - menuRow.length }).map((_, idx) => (
                        <td key={'empty-' + idx} />
                      ))}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="text-gray-500">No submenus available for this section.</div>
          )}
        </div>
  );
};

export default AgentLandingPage;
